/* eslint-disable max-len, no-plusplus */

const isProduction = window.location.origin.includes('universe.com')
const isConsentRevoked = () => !window.OnetrustActiveGroups?.includes('C0004')

const iframe = document.createElement('iframe')
iframe.setAttribute('id', 'google-analytics-frame')
iframe.setAttribute('width', 0)
iframe.setAttribute('height', 0)
iframe.setAttribute('src', 'about:blank')
iframe.setAttribute('style', 'display:none')
document.body.appendChild(iframe)

let writeIframeContentRetries = 10

const writeIframeContent = (googleAnalyticsCode) => {
  // We may have to wait for Onetrust to load
  // In order to know that they haven't revoked consent
  if (isProduction && !window.OnetrustActiveGroups) {
    if (writeIframeContentRetries--) setTimeout(writeIframeContent, 500)
    return false
  }

  // Don't render iframe if we don't have permission
  if (isProduction && isConsentRevoked()) return false

  const doc = iframe.contentWindow.document
  doc.open()
  doc.write(`
    <html>
      <head>
        <script async src="https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsCode}"></script>
        <script>
          window.dataLayer = window.dataLayer || [];
          function gtag(){ dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', '${googleAnalyticsCode}');
        </script>
      </head>
    </html>
  `)
  return doc.close()
}

const removeIframeContent = () => {
  const doc = iframe.contentWindow.document
  doc.open()
  doc.write('')
  doc.close()
}

const initGoogleAnalytics = (googleAnalyticsCode) => {
  if (iframe.contentWindow.document.readyState === 'complete') {
    writeIframeContent(googleAnalyticsCode)
  } else {
    iframe.onload = writeIframeContent
    // Just in case the onload doesn't fire due to race conditions
    setTimeout(writeIframeContent, 5000)
  }
}

export default (googleAnalyticsCode) => {
  initGoogleAnalytics(googleAnalyticsCode)

  // Listenener for OneTrust consent changes
  window.OptanonWrapper = () => {
    if (isConsentRevoked()) {
      removeIframeContent()
    } else {
      initGoogleAnalytics(googleAnalyticsCode)
    }
  }
}
